/**
 * Generates a product URL within the context of the provided collection.
 * @see https://shopify.dev/api/liquid/filters#within
 */
export const withinFormatter = {
  name: 'within',
  read(productUrl: string, collectionHandle?: string) {
    if (!productUrl) {
      throw new Error('[withinFormatter] No product url delivered!')
    }

    if (!collectionHandle) {
      return productUrl
    }

    return `/collections/${collectionHandle}${productUrl}`
  },
}
